import { render, staticRenderFns } from "./AdminPanelDasboardUsers.vue?vue&type=template&id=6ade856e"
import script from "./AdminPanelDasboardUsers.vue?vue&type=script&lang=js"
export * from "./AdminPanelDasboardUsers.vue?vue&type=script&lang=js"
import style0 from "./AdminPanelDasboardUsers.vue?vue&type=style&index=0&id=6ade856e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports